<template>

</template>

<script>
import CONST from "@/utils/Constants";
import GAMixins from "../mixins/GAMixins";

export default {
  name: "CartComponent",
  data() {
    return {
      entry: null,
      newQty: null,
      dimValue: null,
    }
  },
  mixins: [
    GAMixins
  ],
  methods: {
    printCartRemove(data) {
      ACC.log.group("printCartRemove")
      ACC.log.info({'data': data})
      if (data.entry != null && data.entry.product != null) {
        const entry = {
          event: 'remove_from_cart',
          ecommerce: {
            commercial_organization: this.getCommercialOrganization(),
            items: [
              this.buildProductGAObject(data.entry.product, this.getPrice(data.entry.totalPrice), data.entry.flagVista, Number(data.entry.quantity), data.entry.descriptionCausality, data.entry.collection, null, this.getCollectionMap(data.entry), data.entry)
            ]
          }
        }

        this.pushEvent(entry);
        console.groupEnd();
      }

    },

    printCartView(entriesGroup) {
      ACC.log.group("printCartView")
      ACC.log.info(entriesGroup.entries)

      if (!!entriesGroup.entries.length) {
        const entry = {
          event: 'view_cart',
          ecommerce: {
            currency: ACC.config.user.currency.isocode,
            commercial_organization: this.getCommercialOrganization(),
            value: entriesGroup.conditions.totalCart.value,
            items: this.getProductEntries(entriesGroup.entries)
          },
        }
        this.pushEvent(entry);
        console.groupEnd();
      }
    },
  },
  created() {
    GoogleAnalyticsEventBus.$on(CONST.EVENT.GOOGLE.CART.VIEW, entriesGroup => {
      this.printCartView(entriesGroup);
    });

    GoogleAnalyticsEventBus.$on(CONST.EVENT.GOOGLE.CART.REMOVE, entry => {
      this.entry = entry;
      this.printCartRemove(entry);
    });
  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/global/lptGoogleAnalytics/components/CartComponent.vue